var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui labeled basic icon button",on:{"click":_vm.back}},[_c('i',{staticClass:"long arrow alternate left icon"}),_vm._v("\n  "+_vm._s(_vm.$t('navigation.back'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }